import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, EventEmitter, Output, Inject, PLATFORM_ID, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MapsService } from '../services/maps/maps.service';
import { PdvService } from '@app/services/pdv/pdv.service';

declare var google: any;

@Directive({
  selector: '[googleplace]',
  providers: [NgModel]
})

export class GoogleplaceDirective {
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  maps;
  modelValue: any;
  autocomplete: any;
  private _el: HTMLElement;


  constructor(
    private el: ElementRef,
    private model: NgModel,
    private mapsService: MapsService,
    private pdvService: PdvService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    const subs4 = this.pdvService.pdv.subscribe((pdv) => {
      this.maps = pdv.maps;
    });
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(
        () => {
          this._el = this.el.nativeElement;
          this.modelValue = this.model;
          var input = this._el;
          this.mapsService.doSomethingGoogley(this.maps).then((data) => {
            console.log(data)
            this.autocomplete = new google.maps.places.Autocomplete(input, { types: ["geocode"], componentRestrictions: { country: "fr" } });
            google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
              var place = this.autocomplete.getPlace();
              this.invokeEvent(place);
            });
          })
        }, 1000
      )
    }
  }
}